var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('ToolBar'),_c('portal-switch',{staticClass:"portal-switch"})],1),_c('v-container',{staticClass:"canvas pb-12 overflow-auto"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }